import { FocusKeyManager } from '@angular/cdk/a11y';
import { AfterViewInit, Component, Input, QueryList, ViewChildren } from '@angular/core';
import { TimeSeriesSku, TimeSeriesSkuCollection } from '../../models';
import { SkuTimeSeriesTableRowComponent } from '../sku-time-series-table-row/sku-time-series-table-row.component';
import { TimeSeriesIndices } from '../sku-time-series-table.component';

@Component({
    selector: 'via-sku-time-series-table-group',
    templateUrl: './sku-time-series-table-group.component.html',
    styleUrls: ['./sku-time-series-table-group.component.scss'],
})
export class SkuTimeSeriesTableGroupComponent implements AfterViewInit {
    @Input()
    public isShowingAllPrices: boolean;

    @Input()
    public showRegularPrice: boolean;

    @Input()
    public selectedSortType: string;

    @Input()
    public data: TimeSeriesSkuCollection;

    @Input()
    public timeSeriesIndices: TimeSeriesIndices;

    @Input()
    public imageSasParams: string;

    @ViewChildren(SkuTimeSeriesTableRowComponent)
    public tableRowElements: QueryList<SkuTimeSeriesTableRowComponent>;

    public isExpanded = true;
    public keyManager: FocusKeyManager<any>;


    public toggleGroup(): void {
        this.isExpanded = !this.isExpanded;
    }

    public groupHeaderKeyEvents(event: KeyboardEvent): void {
        if (event.key === ' ' || event.key === 'Enter') {
            this.toggleGroup();
        }
    }

    public tableRowKeyEvents(event: KeyboardEvent): void {
        if (this.keyManager.activeItemIndex === -1) {
            this.keyManager.setFirstItemActive();
        }

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            this.keyManager.onKeydown(event);
        }
    }

    public ngAfterViewInit(): void {
        this.keyManager = new FocusKeyManager(this.tableRowElements);
    }

    public trackByMethod(index:number, el:TimeSeriesSku):number{
        return el.skuDetails.itemId
    }

}
